import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FooterComponent } from './footer/footer.component';
import { MaterialModule } from '../material-module';
import { LoadComponent } from './loader/load.component';
import { ToastComponent } from '../../../../shared/src/app/toast/toast/toast.component';
// import { VesselScheduleTimelineComponent } from './vessel-schedule-timeline/vessel-schedule-timeline.component';



@NgModule({
  declarations: [LoadComponent, ToastComponent],
  imports: [
    CommonModule,
    MaterialModule,
  ],
  exports: [LoadComponent],

})
export class SharedModule { }
